<template>
    <div>
      <div class="modal hide fade" id="modalCustomerList" tabindex="-1" role="dialog" aria-labelledby="modalCustomerList" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                Customer List Sales
              </h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="table-responsive">
                <div class="form-inline ml-auto">
                  <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refresh">
                    <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                  </button>
                  <div class="button-group">
                    rows:
                    <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                      <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                    </select>
                    <span class="mr-1">
                      Total rows: <b>{{ rowsTotal }}</b>
                    </span>
                  </div>

                  <div class="form-group mx-sm-3 mb-2">
                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                  </div>
                  <span class="mr-1">
                    page:
                    <select v-model="currentPage">
                      <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                    </select>
                    / {{ pageLength }}
                  </span>
                  <nav aria-label="Page navigation example" class="pull-right">
                      <ul class="pagination">
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                              </a>
                          </li>
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </a>
                          </li>
                      </ul>
                  </nav>
                </div>
                <table class="table table-item mb-0 table-sm table-hover">
                    <thead>
                        <tr>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                              {{ t.name }}
                              <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="9" style="text-align: center;">
                          <!-- <i>No Data</i> -->
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </td>
                      </tr>
                        <tr v-for="u in filterData" v-bind:key="u.id" @click="selectCustomer(u.id)" data-dismiss="modal" aria-label="Close" style="cursor: pointer">
                          <td>
                            <span class="badge badge-success" v-if="u.rating_id === 'good'">{{ u.rating }}</span>
                            <span class="badge badge-danger" v-else-if="u.rating_id === 'bad'">{{ u.rating }}</span>
                            <span class="badge badge-warning" v-else>{{ u.rating }}</span>
                          </td>
                          <td>{{ u.termDueDate }}</td>
                          <td><b>{{ u.customer_no }}</b></td>
                          <td>{{ u.name }}</td>
                          <td>{{ u.group }}</td>
                          <td>{{ u.phone }}</td>
                          <td>{{ u.address }}</td>
                          <td>{{ u.notes }}</td>
                        </tr>
                    </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CustomerListModal',
  data () {
    return {
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Rating',
        prop: 'rating_id'
      }, {
        name: 'Term Due',
        prop: 'term_due_id'
      }, {
        name: 'Customer No.',
        prop: 'customer_no'
      }, {
        name: 'Name',
        prop: 'name'
      }, {
        name: 'Group',
        prop: 'group'
      }, {
        name: 'Phone',
        prop: 'phone'
      }, {
        name: 'Address',
        prop: 'address'
      }, {
        name: 'Notes',
        prop: 'notes'
      }],
      selectAll: false,
      selected: []
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      customerList: state => state.customers.customerListLite
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.customerList.length
      } else {
        count = this.customerList
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.customerList.length
      } else {
        count = this.customerList
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // this.currentPage = 1
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.customerList.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async refresh () {
      this.$store.commit('SET_CUSTOMER_LIST_LITE', [])
      await this.$store.dispatch('getCustomerListLite')
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    selectCustomer: function (id) {
      const customer = this.customerList.find(d => d.id === id)
      console.log(customer)
      this.$emit('selectCustomerList', customer)
    }
  }
}
</script>
